<app-view-dashboard-component>
  <div modalTitle>
    {{ 'nav.sales' | translate }}
  </div>
  <div class="ion-margin-top">
    <app-offers></app-offers>
  </div>
</app-view-dashboard-component>